//@ts-nocheck
import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import PageWrapper from "../../../layout/PageWrapper/PageWrapper";
import Button from "../../../components/bootstrap/Button";
import Page from "../../../layout/Page/Page";
import Card, {
  CardBody,
  CardHeader,
} from "../../../components/bootstrap/Card";
import PaginationButtons from "../../../components/PaginationButtons";
import Dropdown, {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "../../../components/bootstrap/Dropdown";
import ConfirmationModal from "../ConfirmationModal";
import userState from "../../../shared/mobx/user-state";
import LoaderWrapper from "../../../layout/Wrapper/LoaderWrapper";
import AddUserModal from "./AddUserModal";
import ViewContactUsModal from "./ViewContactUsModal"; // Import the ViewContactUsModal
import ReplyModal from "./ReplyModal";
import SearchBar from "../../../components/SearchBar";
import ascendingIcon from "../../../sorting/ascending-sorting.png";
import descendingIcon from "../../../sorting/descending-sorting.png";

const ContactPage = () => {
  const [users, setUsers] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setLoading] = useState(true);
  const [perPage, setPerPage] = useState(10); // Default items per page
  const [totalRecords, setTotalRecords] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false); // State for View Modal
  const [refreshValue, setRefresh] = useState(0);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [user, setUser] = useState<any>({});
  const [selectedContact, setSelectedContact] = useState<any>(null); // Selected contact for viewing
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [isReplyModalOpen, setIsReplyModalOpen] = useState(false); // State for Reply Modal
  const [selectedReplyContact, setSelectedReplyContact] = useState<any>(null); // State for selected contact for reply
  const [searchQuery, setSearchQuery] = useState<string>(""); // State for search term
  const [filteredData, setFilteredData] = useState<any[]>([]); // State for filtered data
  const [sortField, setSortField] = useState<string>("createdAt"); // New state for sorting field
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc"); // New state for sorting order

  const handleSearch = (query: string) => {
    setSearchQuery(query);
    const searchTerms = query.toLowerCase().trim();
    const results = users.filter(
      (user) =>
        user.full_name.toLowerCase().includes(searchTerms) ||
        user.email.toLowerCase().includes(searchTerms)
    );
    setFilteredData(results);
    setCurrentPage(1); // Reset to the first page on search
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const d = await userState.getcontactList({
        per_page: perPage, // Use the perPage state for dynamic pagination
        page: currentPage, // Use the currentPage state for pagination
        search: searchQuery, // Use the searchQuery state for searching
        order_by: sortOrder, // Use the sortOrder state for sorting
        order_by_field: sortField, // New parameter for sorting field
      });
      const { total_records } = d;
      setTotalRecords(total_records);
      setUsers(d?.data || []);
      // setTotalRecords(d?.total_records || 0);
      setFilteredData(d?.data || []); // Initialize filtered data
      setLoading(false);
    };
    fetchData();
  }, [currentPage, perPage, searchQuery, sortOrder, sortField, refreshValue]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const handleOpenViewModal = (contact) => {
    setSelectedContact(contact);
    setIsViewModalOpen(true);
  };
  const handleCloseViewModal = () => setIsViewModalOpen(false);
  const handleOpenReplyModal = (contact) => {
    setSelectedReplyContact(contact); // Set the selected contact
    setIsReplyModalOpen(true); // Open the modal
  };

  const handleCloseReplyModal = () => {
    setIsReplyModalOpen(false); // Close the modal
  };

  const refresher = () => {
    setUser({});
    setRefresh(refreshValue + 1);
  };

  const handleDelete = async (item) => {
    setUser(item);
    setConfirmationModal(true);
  };

  const deleteAction = async () => {
    setDeleteLoader(true);
    await userState.deleteContact(user.id);
    setUser({});
    setConfirmationModal(false);
    refresher();
    setDeleteLoader(false);
  };

  const toggleSortOrder = (field: string) => {
    if (sortField === field) {
      setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("desc"); // Reset to ascending when changing field
    }
  };

  const sortedData = filteredData.sort((a, b) => {
    const comparison = a[sortField]?.localeCompare(b[sortField]);
    return sortOrder === "asc" ? comparison : -comparison; // Sort based on order
  });

  // const paginatedData = items.slice((currentPage - 1) * perPage, currentPage * perPage); // Get current page data

  return (
    <PageWrapper title="ContactUs">
      <Page container="fluid">
        <div className="row">
          <div className="col-12">
            <Card>
              <CardHeader borderSize={1}>
              <div className="search-wrap">
                <span className="fw-bold">Contact Inquiries</span>
                      <div className="d-flex justify-content-end">
                        <SearchBar
                          fetchData={() => {}}
                          placeholder="Search User.."
                          onSearch={handleSearch}
                        />
                    </div>
              </div>
             </CardHeader>
              <CardBody className="table-responsive">
                <LoaderWrapper isLoading={isLoading} data={sortedData}>
                  <>
                    <table className="table table-modern">
                      <thead>
                        <tr>
                          <th onClick={() => toggleSortOrder("full_name")}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                              }}
                            >
                              Name
                              {sortField === "full_name" &&
                                (sortOrder === "asc" ? (
                                  <img
                                    src={ascendingIcon}
                                    alt="Ascending"
                                    style={{
                                      marginLeft: "5px",
                                      verticalAlign: "middle",
                                      cursor: "pointer",
                                      width: "16px",
                                      height: "16px",
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={descendingIcon}
                                    alt="Descending"
                                    style={{
                                      marginLeft: "5px",
                                      verticalAlign: "middle",
                                      cursor: "pointer",
                                      width: "16px",
                                      height: "16px",
                                    }}
                                  />
                                ))}
                            </div>
                          </th>

                          <th onClick={() => toggleSortOrder("email")}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                              }}
                            >
                              Email
                              {sortField === "email" &&
                                (sortOrder === "asc" ? (
                                  <img
                                    src={ascendingIcon}
                                    alt="Ascending"
                                    style={{
                                      marginLeft: "5px",
                                      verticalAlign: "middle",
                                      cursor: "pointer",
                                      width: "16px",
                                      height: "16px",
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={descendingIcon}
                                    alt="Descending"
                                    style={{
                                      marginLeft: "5px",
                                      verticalAlign: "middle",
                                      cursor: "pointer",
                                      width: "16px",
                                      height: "16px",
                                    }}
                                  />
                                ))}
                            </div>
                          </th>

                          <th onClick={() => toggleSortOrder("message")}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                              }}
                            >
                              Message
                              {sortField === "message" &&
                                (sortOrder === "asc" ? (
                                  <img
                                    src={ascendingIcon}
                                    alt="Ascending"
                                    style={{
                                      marginLeft: "5px",
                                      verticalAlign: "middle",
                                      cursor: "pointer",
                                      width: "16px",
                                      height: "16px",
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={descendingIcon}
                                    alt="Descending"
                                    style={{
                                      marginLeft: "5px",
                                      verticalAlign: "middle",
                                      cursor: "pointer",
                                      width: "16px",
                                      height: "16px",
                                    }}
                                  />
                                ))}
                            </div>
                          </th>

                          <th onClick={() => toggleSortOrder("createdAt")}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                              }}
                            >
                              Received Date
                              {sortField === "createdAt" &&
                                (sortOrder === "asc" ? (
                                  <img
                                    src={ascendingIcon}
                                    alt="Ascending"
                                    style={{
                                      marginLeft: "5px",
                                      verticalAlign: "middle",
                                      cursor: "pointer",
                                      width: "16px",
                                      height: "16px",
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={descendingIcon}
                                    alt="Descending"
                                    style={{
                                      marginLeft: "5px",
                                      verticalAlign: "middle",
                                      cursor: "pointer",
                                      width: "16px",
                                      height: "16px",
                                    }}
                                  />
                                ))}
                            </div>
                          </th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sortedData.map((item) => (
                          <tr key={item.id}>
                            <td>{item.full_name}</td>
                            <td>{item.email}</td>
                            <td style={{ width: "30%" }}>{item.message}</td>
                            <td>
                              {dayjs(item.createdAt).format("MM-DD-YYYY")}
                            </td>
                            <td>
                              <Dropdown>
                                <DropdownToggle hasIcon={false}>
                                  <Button
                                    icon="MoreHoriz"
                                    aria-label="More options"
                                  />
                                </DropdownToggle>
                                <DropdownMenu isAlignmentEnd>
                                  <DropdownItem>
                                    <Button
                                      onClick={() => handleOpenViewModal(item)}
                                      icon="Visibility"
                                    >
                                      View
                                    </Button>
                                  </DropdownItem>
                                  <DropdownItem>
                                    <Button
                                      onClick={() => handleDelete(item)}
                                      icon="Delete"
                                    >
                                      Delete
                                    </Button>
                                  </DropdownItem>
                                  <DropdownItem>
                                    <Button
                                      onClick={() => handleOpenReplyModal(item)}
                                      icon="Reply"
                                    >
                                      Reply
                                    </Button>
                                  </DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <PaginationButtons
                      data={filteredData}
                      label="users"
                      setCurrentPage={setCurrentPage}
                      currentPage={currentPage}
                      perPage={perPage}
                      setPerPage={setPerPage}
                      totalItems={totalRecords}
                    />
                  </>
                </LoaderWrapper>
              </CardBody>
            </Card>
          </div>
        </div>
      </Page>
      {isModalOpen ? (
        <AddUserModal
          refresher={refresher}
          user={user}
          isOpen={isModalOpen}
          onClose={handleCloseModal}
        />
      ) : null}
      <ConfirmationModal
        isOpen={confirmationModal}
        setIsOpen={setConfirmationModal}
        loading={deleteLoader}
        title="Confirmation?"
        message="Are you sure you want to delete this inquiry?"
        handleAction={deleteAction}
      />
      {isViewModalOpen ? (
        <ViewContactUsModal
          isOpen={isViewModalOpen}
          onClose={handleCloseViewModal}
          contactMessages={[selectedContact]} // Pass the selected contact message
        />
      ) : null}
      {isReplyModalOpen && (
        <ReplyModal
          isOpen={isReplyModalOpen}
          onClose={handleCloseReplyModal}
          contact={selectedReplyContact} // Pass the selected contact for reply
        />
      )}
    </PageWrapper>
  );
};

export default ContactPage;
